import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import DateBox from 'devextreme-react/date-box';
import notify from 'devextreme/ui/notify';
import DeleteReceiptDialog from "./DeleteReceiptDialog";
import LookupPopup from './LookupPopup';
import ItemModeGrid from "./ItemModeGrid";
import "react-datepicker/dist/react-datepicker.css";
import { Localization } from "../../common/Localization";
import DataSource from "devextreme/data/data_source";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Change_Receipt } from "../../redux/actions/receipt";
import { Reset_Change_Receipt_Items } from "../../redux/actions/receipt";
import * as PermissionsConstants from "../../const/constants";
import { Reset_Items } from "../../redux/actions/receipt";
import { alert, confirm } from 'devextreme/ui/dialog';
import { SelectBox } from 'devextreme-react/select-box';
import { disableTransDate, ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import { GridLayout } from "../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { createConcurrencyAwareStore, refreshGridOnConflict } from "../../common/dataStore";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import { MESSAGES } from "../../common/Messages";
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import {
  Column,
  DataGrid,
  Sorting,
  Paging,
  Pager,
  ColumnHeaderFilter,
  Selection,
  GroupPanel,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Editing,
  Export,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import Consignee from "./consignee/AddConsignee";
import ScrollView from "devextreme-react/scroll-view";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import ToolbarAccordian, { Item as ItemAccordian } from "devextreme-react/toolbar";
import AccordionReact from 'devextreme-react/accordion';
import { TextBox } from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react';
import { GetFormatedDateWithTime } from '../../common/Utils';
import { useLocation } from "react-router-dom";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
var detailDataGridMode = "ExpressLotMode";
var detailItemDataGridMode = "ItemMode";
let isAbecasUser = false;
var detailDataGrid = React.createRef();
var customerRowId = "notset";
const ChangeReceipt = (props) => {
  const consigneeLookup = 0;
  const shipperLookup = 1;
  const carrierLookup = 2;
  const customerLookup = 3;
const location = useLocation();
const searchParams = new URLSearchParams(location.search);
const urlTransactionId = searchParams.get("rowId");
const urlCustomerId = searchParams.get("customerId");
// Fallback values from Redux
const fallbackTransactionId = props.ReceiptReducer.receipt[0]?.rowid;
const fallbackCustomerId = props.ReceiptReducer.receipt[0]?.rCustomer;
  let detailDataGridModes;
  if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
      { value: 'ItemMode', text: 'Item Mode' },
    ];
  } else {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
    ];
  }
  const module = "WM";
  const recordType = "R";
const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  var changeReceiptItemsObect = props.ReceiptReducer.changeReceiptItems;
  
  isAbecasUser = props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE;
  const [lookupDataList, setLookupDataList] = useState([]);
  const { rolePermissions } = props.ReceiptReducer;
  const dispatch = useDispatch();
  const [currentLayout, setCurrentLayout] = useState("Default");
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
 
  const [displayItemModeGrid, setDisplayItemModeGrid] = useState(false);
  const [reloadKey, setReloadKey] = useState(0); 
  const transactionId = urlTransactionId || fallbackTransactionId;
  const [headerId, setHeaderId] = useState(transactionId);
  const rCustomer = urlCustomerId || fallbackCustomerId;
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [showIndicator, setShowIndicator] = useState(true);
  const [selectedValue, setSelectedValue] = useState(detailDataGridMode);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const position = { of: '#accordion-containe2' };
  if (customerRowId == "notset") {
    customerRowId = "";
    if (rCustomer != null && rCustomer != undefined) {
      customerRowId = rCustomer;
    }
  }

  const history = useHistory();
  const [openDialogForTransaction, setOpenDialogForTransaction] =
    useState(false);
  const [guidForconsignee, setGuidForConsginee] = useState([]);
  const [guidForShipper, setGuidForShipper] = useState([]);
  const [guidForCarrier, setGuidForCarrier] = useState([]);
  const [guidForCustomer, setGuidForCustomer] = useState([]);
  const [shipperData, setShipperData] = useState({});
  const [carrierData, setCarrierData] = useState({});
  const [consigneeData, setConsigneeData] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [concurrentDialogForTransaction, setConcurrentDialogForTransaction] =
    useState(false);
  const [rowId, setRowId] = useState("");

  const initialTotals = {
    items: 0.00,
    ordered: 0.00,
    netWeight: 0.00,
    actual: 0.00,
    grossWeight: 0.00,
    inventory: 0.00,
    amount: 0.00,
  };
  const [selectedTotals, setSelectedTotals] = useState(initialTotals);
  
  const changeTotals = async () => {
    try {
      const headerId = rowId || transactionId;
      if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
        setSelectedTotals(initialTotals);
      } else {
        const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Transaction.GetTotals}`, {
          params: { headerRowId: headerId },
          headers: { access_token: accessToken, Authorization: `Bearer ${accessToken}` },
        });
        const result = response.data?.result || response.data;
        setSelectedTotals(result);
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    }
  }

  const [consigneeIdInputToDisable, setConsigneeIdInputToDisable] =
    useState(false);
  const [consigneeSearchDisable, setConsigneeSearchDisable] = useState(false);
  const [consigneeInfoInputToDisable, setConsigneeInfoInputToDisable] =
    useState(false);
  const [consigneeInfo, setConsigneeInfo] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [allowedReceiptDeleteBtn, setAllowedReceiptDeleteBtn] = useState(false);
  const [allowedShipmentDeleteBtn, setAllowedShipmentDeleteBtn] = useState(false);
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
  const [dataSourceCarrier, setDataSourceCarrier] = useState(null);
  const [transaction, setTransaction] = useState({
    recordNumber: "",
    shipperbolnumber: "",
    reference: "",
    container: "",
    transactionnumber: "",
    transactiondate: "",
    actualreceivedshipeddate: "",
    rShipper: "",
    shipperVal: "",
    consigneeVal: "",
    carrierVal: "",
    comment: "",
    rCarrier: "",
    rowid: transactionId,
    showonlyActiveLots: "",
    showonlyItemsWithZeroQuantity: "",
    freightChargeType: "",
    transactiontype: "",
    rCustomer: "",
    customerVal: "",
    profilecode: "",
    userDefinedReference2: ""
  });
  const {
    recordNumber,
    shipperbolnumber,
    reference,
    userDefinedReference2,
    transactionnumber,
    comment,
    transactiondate,
    actualreceivedshipeddate,
    freightChargeType,
    transactionGroup
  } = transaction;
  const [addConsigneePopup, setAddConsigneePopup] = useState(false);
  const [consigneeIdPopupValue, setConsigneeIdPopupValue] = useState("");
  const [detailCount, setDetailCount] = useState(0);
  const [customerDisabled, setCustomerDisabled] = useState(false);
  const [printButtonDisabled, setPrintButtonDisabled] = useState(transaction?.transactionnumber ? false : true);

  const handleClosePopUpCallback = (ChildData) => {
    setConsigneeIdPopupValue(ChildData.rowid);
    setTransaction({
      ...transaction,
      consigneeId: ChildData.ridentity
    });

    setConsigneeData({
      rowid: ChildData.ridentity,
      name: ChildData.name,
      identityId: ChildData.identityid,
    });

    setConsigneeInfo(getConsigneeInfo(ChildData));
    setAddConsigneePopup(false);
    console.log(ChildData);
  };
  const handleClickPopUpOpen = () => {
    setAddConsigneePopup(true);
  };
  const hideConsigneePopup = () => {
    setAddConsigneePopup(false);
  };

  const loadTransaction = () => {
    setLoading(true);
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionById}?id=${transactionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        if (!res.data || !res.data.transaction) {
          history.push("/wm/transaction");
          return;
        }
        setRowId(res.data.transaction.rowid);
        changeTotals();
        setLoading(false);

        let tempShipperArray = new Array();
        tempShipperArray.push(res.data.shipper);
        setGuidForShipper(tempShipperArray);
        setShipperData(res.data.shipper);

        let tempCarrierArray = new Array();
        tempCarrierArray.push(res.data.carrier);
        setGuidForCarrier(tempCarrierArray);
        setCarrierData(res.data.carrier);

        let tempConsignneArray = new Array();
        tempConsignneArray.push(res.data.consigneeInfo);
        setGuidForConsginee(tempConsignneArray);
        setConsigneeData(res.data.consigneeInfo);

        let tempCustomerArray = new Array();
        tempCustomerArray.push(res.data.customer);
        setGuidForCustomer(tempCustomerArray);
        setCustomerData(res.data.customer);
        setDetailCount(res.data.transaction.detailCount);
        if (res.data.transaction.detailCount == 0) {
          setCustomerDisabled(false);
        }
        else {
          setCustomerDisabled(true);
        }

        let data = {
          rowid: res.data.transaction.rowid,
          shipperbolnumber: res.data.transaction?.shipperbolnumber,
          transactionnumber: res.data.transaction?.transactionnumber,
          recordNumber: res.data.transaction?.recordNumber,
          transactiondate: res.data.transaction?.transactiondate,
          actualreceivedshipeddate: res.data.transaction?.actualreceivedshippeddatetime,
          comment: res.data.transaction?.comment,
          reference: res.data.transaction?.reference,
          userDefinedReference2: res.data.transaction?.userdefinedreference2,
          carrierVal: res.data.carrier?.name,
          rCarrier: res.data.carrier?.rowid,
          shipperVal: res.data.shipper?.name,
          rShipper: res.data.shipper?.rowid,
          rConsignee: res.data.consigneeInfo?.rowid,
          consigneeVal: res.data.consigneeInfo?.name,
          freightChargeType: res.data.transaction?.freightchargetype,
          transactionGroup: res.data.transaction?.transactiongroup,
          transactiontype: res.data.transaction?.transactiontype,
          customerVal: res.data.customer?.name,
          rCustomer: res.data.customer?.rowid,
          profilecode: res.data.profile?.profilecode,
          // Opaque optimistic-concurrency token, echoed back unchanged on save.
          concurrencyToken: res.data.transaction?.concurrencyToken
        };
        setConsigneeInfo(res.data?.consigneeInfo?.info);

        console.log(data);
        setTransaction(data);
        setPrintButtonDisabled(false);
        
      })
      .catch((err) => {
        console.log(err, "error in change reciept screen");
        history.push("/wm/transaction");
      });
  };
  const handelSalesOrderChange = (e) => {

    const name = "transactionGroup";
    const value = e.value;
    if (value) {
      setTransaction((prevTransaction) => ({
        ...prevTransaction,
        [name]: value,
      }));
    }
  };
  const onInputChangeForTransaction = (e) => {
    setTransaction({ ...transaction, [e.target.name]: e.target.value });
  };
  const handelCommentChange = (e) => {
    const name = "comment";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const onChangeTransactionDate = (e) => {
    setTransaction({ ...transaction, "transactiondate": e });
  };

  const onChangeactualrcvshipedDate = (e) => {
    var compare = Date.parse(transaction.actualreceivedshipeddate);
    if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
      var today = Date().now();
      if (compare < today) {
        alert("Receiving date must be greater than today's date", "Error");
        return;
      }
    }

    setTransaction({ ...transaction, "actualreceivedshipeddate": e });
  };

  const handelShippingDateChange = (e) => {
    const name = "actualreceivedshipeddate";
    const value = e.value;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
      if (value) {
        if (new Date(value) < today) {
          notify(
            {
              message: "Receiving date must be greater than today's date",
              width: 100,
            },
            'error',
            3000,
          );
          setTransaction((prevTransaction) => ({
            ...prevTransaction,
            [name]: null, 
          }));
          return;
        }
      }
    }
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const handleSearchForConsignee = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 0;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForConsginee(resp.data.lookups);
      });
  };
  const debouncedChangeHandlerForConsignee = useCallback(
    debounce(handleSearchForConsignee, 600),
    []
  );
  const handleSearchForShipper = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 1;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForShipper(resp.data.lookups);
        /*
        setShipperData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };
  const debouncedForShipper = useCallback(
    debounce(handleSearchForShipper, 800),
    []
  );

  const onItemClick = (e) => {
    setTransaction({ ...transaction, freightChargeType: e.value });

  }
  const handleSearchForCarrier = (e) => {
    let key = e.target.value;
    const lookup = 2;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCarrier(resp.data.lookups);
        /*
        setCarrierData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };
  const debouncedForCarrier = useCallback(
    debounce(handleSearchForCarrier, 800),
    []
  );

  const handleSearchForCustomer = (e) => {
    let key = e.target.value;
    const lookup = 3;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCustomer(resp.data.lookups);
      });
  };

  const debouncedForCustomer = useCallback(
    debounce(handleSearchForCustomer, 800),
    []
  );

  const exportReport = (e) => {
    e.event.stopPropagation();
    var report = new Object();
    report.Key = "WMR0049";
    report.Name = "WMR0049";

    var whereInfo = new Object();
    whereInfo.FieldType = 0; //ParameterTypeEnum.String;
    whereInfo.FieldName = "TRANSACTIONNUMBER";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "WMTRANSACTIONHEADER.TRANSACTIONNUMBER";
    whereInfo.From = transaction.transactionnumber;
    whereInfo.To = transaction.transactionnumber;
    report.FilterWhereInfoList = [];
    report.FilterWhereInfoList.push(whereInfo);
    setLoadIndicatorVisible(true);
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setLoadIndicatorVisible(false);
        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data != undefined
        ) {
          if (res.data.isSuccess) {
            window.open(
              `${window._env_.REACT_APP_APIS}/${data.reports.GetReportFile}?fileName=${res.data.fileName}`,
              "_blank"
            );
          } else {
            alert(
              "Cannot generate report. Error:  " + res.data.errorMessage,
              "Error"
            );
          }
        } else {
          alert("Cannot generate report", "Error");
        }
      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        alert(err, "Error");
      });
  };
  const onUpdateTransaction = async (e) => {
    e.event.stopPropagation();
    var changeTransactionDetailObject = {
      items: changeReceiptItemsObect,
      rowid: rowId,
      shipperbolnumber: shipperbolnumber,
      reference: reference,
      userDefinedReference2: userDefinedReference2,
      transactionnumber: transactionnumber,
      comment: comment,
      transactiondate: GetFormatedDateWithTime(transactiondate),
      actualreceivedshippeddatetime: GetFormatedDateWithTime(actualreceivedshipeddate),
      lastupdatedatetime: transaction.lastupdatedatetime,
      // Tells the API which version of the header this edit started from.
      concurrencyToken: transaction.concurrencyToken,
      freightChargeType: freightChargeType,
      transactionGroup: transactionGroup,
      dbName:
        props.ReceiptReducer.wmTransactionDatabase !== ""
          ? props.ReceiptReducer.wmTransactionDatabase
          : "",
      transactionType: transactionType.transactionType
    };

    if (shipperData !== null) {
      changeTransactionDetailObject.rShipper = shipperData.rowid;
    }
    if (carrierData != null) {
      changeTransactionDetailObject.rCarrier = carrierData.rowid;
    }
    if (consigneeData != null) {
      changeTransactionDetailObject.rConsignee = consigneeData?.rowid;
    }
    if (customerData != null) {
      changeTransactionDetailObject.rCustomer = customerData?.rowid;
    }

    dispatch(Change_Receipt(changeTransactionDetailObject));

    if (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "D") {
      changeTransactionDetailObject.actualreceivedshippeddatetime = null;
    }
    setLoadPanelVisible(true);
    await axios.post
      (
        `${window._env_.REACT_APP_APIS}/${data.Receipt.ValidateReference}`,
        changeTransactionDetailObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setTimeout(hideLoadPanel, 1000);
        if (res.data.type == "warning") {
          let result = confirm("<i>" + res.data.message + "</i>", "Warning");
          result.then((dialogResult) => {
            if (dialogResult) {
              UpdateTransaction(changeTransactionDetailObject);
            }
          });
        }
        else if (res.data.type == "error") {
          alert(res.data.message, "Error");
        }
        else {
          UpdateTransaction(changeTransactionDetailObject);
        }
      })
      .catch((err) => {
        setTimeout(hideLoadPanel, 1000);
        alert(err, "Error");
      });
  };

  const UpdateTransaction = async (changeTransactionDetailObject) => {
    await axios.post
      (
        `${window._env_.REACT_APP_APIS}/${data.Receipt.UpdateTransactions}`,
        changeTransactionDetailObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          // Adopt the token for the version just written, or the next save echoes the one this
          // screen was opened with and falsely conflicts.
          if (res.data.wmtransactionheader?.concurrencyToken) {
            setTransaction((prev) => ({
              ...prev,
              concurrencyToken: res.data.wmtransactionheader.concurrencyToken
            }));
          }
          handleClickOpen();
          setPrintButtonDisabled(false);
        }
        else {
          alert(res.data.message, "Error");
          setConcurrentDialogForTransaction(true);
          setPrintButtonDisabled(true);
        }
      })
      .catch((err) => {
        // A real version conflict now comes back as 409 and the shared interceptor has already
        // raised the "record changed - reload" dialog. Don't also open this screen's own dialog.
        if (err?.[CONCURRENCY_HANDLED]) {
          return;
        }
        // A refusal is now a real 4xx and lands here rather than in the else branch above. Show the
        // actual reason: this used to open the "record changed" dialog for *any* failure, which told
        // the user their data was stale when in fact a business rule had rejected the save.
        alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
        setPrintButtonDisabled(true);
      });
  };

  const closeDialogForTransaction = () => {
    getUpdatedTransactionData();
    handleClose();
    history.push("/wm/transaction");
  };
  const refreshChangeTransaction = () => {
    loadTransaction();
    setConcurrentDialogForTransaction(false);
  };
  const handleClickOpen = () => {
    setOpenDialogForTransaction(true);
  };
  const handleClose = () => {
    let resetItems = [];
    dispatch(Reset_Change_Receipt_Items(resetItems));
    loadTransaction();
    setOpenDialogForTransaction(false);
  };
  const [deleteReceiptDialogOpen, setDeleteReceiptDialogOpen] =
    React.useState(false);
  const handleCloseReceiptDialog = () => {
    setDeleteReceiptDialogOpen(false);
  };
  const handleOpenReceiptDialog = (e) => {
    e.event.stopPropagation();
    setDeleteReceiptDialogOpen(true);
  };
  const [
    showOnlyShippersAttachedToCustomer,
    setShowOnlyShippersAttachedToCustomer,
  ] = useState(false);
  const [
    showOnlyConsigneeAttachedToCustomers,
    setshowOnlyConsigneeAttachedToCustomers,
  ] = useState(false);
  const checkUserPermissions = () => {
    let consigneeAttached = false;
    let shipperAttached = false;

    if (rolePermissions)
    {
      if (rolePermissions[PermissionsConstants.TransactionReceipt] &&  Array.isArray(rolePermissions[PermissionsConstants.TransactionReceipt]))
      {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionReceipt].length; i++) 
        {
          var perm = PermissionsConstants.TransactionReceipt + rolePermissions[PermissionsConstants.TransactionReceipt][i];

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyShippersAttachedToCustomer) 
          {
            setShowOnlyShippersAttachedToCustomer(true);
            shipperAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyConsigneeAttachedToCustomers) 
          {
            setshowOnlyConsigneeAttachedToCustomers(true);
            consigneeAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptDelete) {
            setAllowedReceiptDeleteBtn(true);
          }
        }
      }

      if (rolePermissions[PermissionsConstants.TransactionShipment] &&  Array.isArray(rolePermissions[PermissionsConstants.TransactionShipment]))
      {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionShipment].length; i++) 
        {
          var perm = PermissionsConstants.TransactionShipment + rolePermissions[PermissionsConstants.TransactionShipment][i];

          if (perm === PermissionsConstants.TransactionShipmentDelete) {
            setAllowedShipmentDeleteBtn(true);
            break;
          }
        }
      }
    }

    return {
      consigneeAttached: consigneeAttached,
      shipperAttached: shipperAttached,
    };
  };
  const [transactionType, setTransactionType] = useState({
    transactionType:
      props.rolePermission === PermissionsConstants.TransactionReceipt
        ? "R"
        : props.permission === PermissionsConstants.TransactionAdjustment
          ? "A"
          : "S",
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
  });
  const getUpdatedTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetAllTransactions}`,
        transactionType,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {

        //props.loadUpdatedTransactionsData(res.data);
      });
  };
  const disableConsigneeInput = () => {
    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      setConsigneeInfoInputToDisable(true);
      setConsigneeIdInputToDisable(true);
      setConsigneeSearchDisable(true);
    } else {
      setConsigneeInfoInputToDisable(false);
      setConsigneeIdInputToDisable(false);
      setConsigneeSearchDisable(false);
    }
  };
  const detailDataGridModeChanged = (e) => {
    if (e.value == "ItemMode") {
      setHeaderId(transactionId);
      setDisplayItemModeGrid(true);
      setSelectedValue(e.value);
      detailItemDataGridMode = e.value;
    } else {
      setDisplayItemModeGrid(false);
      detailDataGridMode = e.value;
      setSelectedValue(e.value);
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        const instance = detailDataGrid.current.instance();
        if (instance && typeof instance.refresh === 'function') {
          instance.refresh();
        }
      }
    }
  };
  const dataSource = createConcurrencyAwareStore({
      onConflict: refreshGridOnConflict(detailDataGrid, changeTotals),
    key: 'key',
    loadParams:
    {
      recordType: function () {
        return "R";
      },
      itemStatus: function () {
        var request = buildRequest();
        return request.itemStatus;
      },
      transactionHeaderId: function () {
        return transactionId;
      },
      showItemsWithZeroQuantity: function () {
        var request = buildRequest();
        return request.showItemsWithZeroQuantity;
      },
      showonlyActiveLots: function () {
        var request = buildRequest();
        return request.showonlyActiveLots;
      },
      isTransItmsOnly: function () {
        return false;
      },
      mode: function () {
        return detailDataGridMode;
      },
      customerId: function () {
        return customerRowId == null || customerRowId == undefined ? "" : customerRowId;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.getReceiptItems}`,
    updateUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
    onBeforeSend: function (method, ajaxOptions) {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    }
  });

  const buildRequest = () => {
    let filteredPermissions = [];
    let showItemsWithZeroQuantity = false;
    let itemStatus = "";
    let showonlyActiveLots = false;
    Object.entries(rolePermissions).map(([key, values]) => {
      console.log(key);
      if (key === PermissionsConstants.TransactionReceipt) {
        values.forEach((val) => {
          filteredPermissions.push(key + val);
        });
      }
      filteredPermissions.forEach((perm) => {
        if (
          perm ===
          PermissionsConstants.TransactionReceiptViewItemsWithZeroQuantity
        ) {
          showItemsWithZeroQuantity = true;
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveItems
        ) {
          itemStatus = "A";
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveLots
        ) {
          showonlyActiveLots = true;
        }
      });
    });

    let builtRequest = {
      itemStatus: itemStatus,
      module: module,
      recordType: recordType,
      transactionHeaderId: transactionId,
      showItemsWithZeroQuantity: showItemsWithZeroQuantity,
      showonlyActiveLots: showonlyActiveLots,
    };
    return builtRequest;
  };

  const onContentReady = (e) => {
    if (props.oidc.user.profile.hasOwnProperty("WMDETAILDATAGRIDMODE")) {
      e.component.option("value", props.oidc.user.profile.WMDETAILDATAGRIDMODE);
    }
    else {
      e.component.option("value", "ExpressLotMode");
    }
  };

  const onChangeReceiptQuantityUpdate = (e) => {
    if (!e.newData.hasOwnProperty('detailrowid')) {
      e.newData['detailrowid'] = e.oldData['detailrowid'];
    }

    if (!e.newData.hasOwnProperty('headerrowid')) {
      e.newData['headerrowid'] = transactionId;
    }

    if (!e.newData.hasOwnProperty('rowid')) {
      e.newData['rowid'] = e.oldData['rowid'];
    }

    if (!e.newData.hasOwnProperty('lotid')) {
      e.newData['lotid'] = e.oldData['lotid'];
    }

    if (!e.newData.hasOwnProperty('mode')) {
      e.newData['mode'] = detailDataGridMode;
    }

    // Optimistic concurrency: the version the grid was showing. This handler copies a
    // field whitelist rather than merging all of oldData, so the token must be listed.
    if (!e.newData.hasOwnProperty('concurrencyToken')) {
      e.newData['concurrencyToken'] = e.oldData['concurrencyToken'];
    }
  };

  const onRowUpdated = (e) => {

    var count = detailCount;

    if (e.data.isselected) {
      count = count + 1;
    }
    else {
      count = count - 1;
    }

    setDetailCount(count);

    if (count == 0) {
      setCustomerDisabled(false);
    }
    else {
      setCustomerDisabled(true);
    }

    changeTotals();
  };

  useEffect(() => {
    if (!transactionId) {
      history.push("/wm/transaction");
      return;
    }
    loadCustomerAutoComponentData();
    loadCarrierAutoComponentData();
    loadConsigneeAutoComponentData();
    loadShipperAutoComponentData();
    setIsDisabled(disableTransDate(props.oidc.user.profile.LOGINTYPEID));
    loadTransaction();
    checkUserPermissions();
    disableConsigneeInput();

    if (props.oidc.user.profile.hasOwnProperty("WMDETAILDATAGRIDMODE")) {
      detailDataGridMode = props.oidc.user.profile.WMDETAILDATAGRIDMODE;
      setSelectedValue(props.oidc.user.profile.WMDETAILDATAGRIDMODE);
    }

    detailDataGrid.current.instance().option("dataSource", dataSource);
  }, []);
  const [openLookupForm, setOpenLookupForm] = useState(false);
  let [lookupSearchRequest, setLookupSearchRequest] = useState({
    identityIdFrom: "",
    identityIdTo: "",
    name: "",
    lookupType: 0,
    showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
    showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
  });

  const getAllLookupsData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        lookupSearchRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        console.log(res, "res");
        setLookupDataList(res.data.lookups);
      })
      .catch((err) => {
        console.log(err, "err in loading lookups data");
      });
  };
  let [lookupFormName, setLookupFormName] = useState("");
  const openSearchIdsForm = (lookupType) => {
    console.log("hello world.");
    lookupSearchRequest = {
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : "",
      identityIdTo: "",
      name: "",
      lookupType: lookupType,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      ...lookupSearchRequest,
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : ""
    });

    setLookupFormName(
      lookupType === consigneeLookup ? "Consignee" : lookupType === shipperLookup ? "Shipper" : lookupType === carrierLookup ? "Carrier" : "Customer"
    );
    setOpenLookupForm(true);
    getAllLookupsData();
  };
  const closeLookupSearchForm = () => {
    setOpenLookupForm(false);
    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType: 0,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });
  };

  const { identityIdFrom, identityIdTo, name } = lookupSearchRequest;
  const onLookupFieldChange = (e) => {

    if (e.event) {
      const name = e.event.target.name; // Get the name of the TextBox
      const value = e.value; // Get the new value
      setLookupSearchRequest({
        ...lookupSearchRequest,
        [name]: value,
      });
    }
  };
  const resetLookupForm = () => {
    lookupSearchRequest = {
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? consigneeLookup
          : lookupFormName === "Shipper"
            ? shipperLookup
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? consigneeLookup
          : lookupFormName === "Shipper"
            ? shipperLookup
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });

    //dataGrid.current.instance().deselectAll();

    getAllLookupsData();
  };
  const onSearchLookupIds = () => {
    getAllLookupsData();
  };
  const onSelectionChanged = ({ selectedRowsData }) => {
    const lengthArray = selectedRowsData.length;
    let selectedLookupData = selectedRowsData[lengthArray - 1];
    if (lookupFormName === "Consignee") {
      setTransaction({
        ...transaction,
        rConsignee: selectedLookupData == null ? "" : selectedLookupData.rowid,
        consigneeVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });
     
      setConsigneeData(selectedLookupData);
      setGuidForConsginee(selectedRowsData);
      setConsigneeInfo(getConsigneeInfo(selectedLookupData));
    } else if (lookupFormName === "Shipper") {
      setTransaction({
        ...transaction,
        rShipper: selectedLookupData == null ? "" : selectedLookupData.rowid,
        shipperVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });
       

      setShipperData(selectedLookupData);
      setGuidForShipper(selectedRowsData);
    } else if (lookupFormName === "Carrier") {

      setTransaction({
        ...transaction,
        rCarrier: selectedLookupData == null ? "" : selectedLookupData.rowid,
        carrierVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });
      
      setCarrierData(selectedLookupData);
      setGuidForCarrier(selectedRowsData);
    } else {
      setTransaction({
        ...transaction,
        rCustomer: selectedLookupData == null ? "" : selectedLookupData.rowid,
        customerVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });
      
      setCustomerData(selectedLookupData);
      setGuidForCustomer(selectedRowsData);
      customerRowId = selectedLookupData?.rowid;
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        const instance = detailDataGrid.current.instance();
        if (instance && typeof instance.refresh === 'function') {
          instance.refresh();
        }
      }
    }
  };

  const renderConsigneeSearchButton = (disableConsigneeSearch) => {
    if (disableConsigneeSearch) {
      return (
        <Button
          icon="search"

          stylingMode="text"

        />
      );
    } else {
      return (
        <Button
          icon="search"
          onClick={() => openSearchIdsForm(0)}
          stylingMode="text"

        />
      );
    }
  };
  const backToMainGrid = () => {
    let itemArray = [];
    dispatch(Reset_Items(itemArray));
    props.resetQueryForm(null);
    props.transactionCallbackOnUnCheck(0);
    history.push("/wm/transaction");
  };
  const getConsigneeInfo = (data) => {
    let consigneeInfo = "";
    if (data != undefined) {
      consigneeInfo = "Name: ";
      if (data.name !== undefined && data?.name !== null && data?.name !== "") {
        consigneeInfo += data.name.trim();
      }

      consigneeInfo += "\r\nAddress: ";

      if (data.address1 !== undefined && data?.address1 !== null && data?.address1 !== "") {
        consigneeInfo += data.address1.trim();
        consigneeInfo += "\r\n";

      }
      if (data.address2 !== undefined && data?.address2 !== null && data?.address2 !== "") {
        consigneeInfo += data.address2.trim();
        consigneeInfo += "\r\n";

      }
      if (data.city !== undefined && data?.city !== null && data?.city !== "") {
        consigneeInfo += data.city.trim() + " ";

      }
      if (data.state !== undefined && data?.state !== null && data?.state !== "") {
        consigneeInfo += data.state.trim() + " ";
      }
      if (data.zip !== undefined && data?.zip !== null && data?.zip !== "") {
        consigneeInfo += data.zip.trim();
      }
      consigneeInfo += "\r\n";
      if (data.country !== undefined && data?.country !== null && data?.country !== "") {
        consigneeInfo += data.country.trim();
      }
    }
    return consigneeInfo;
  };
  const [isDisabled, setIsDisabled] = useState(false);

  const allowedPageSizes = [10, 100, 200, 500, "all"];
  const gridKey = "423b3fd5-97c3-43b3-80bf-f6e43646a821";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );
  const handleCustomerChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    customerRowId = e.value?.rowid;;
    if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
      const instance = detailDataGrid.current.instance();
      if (instance && typeof instance.refresh === 'function') {
        instance.refresh();
      }
    }
  }, []);
  const [dateSourceCustomer, setDateSourceCustomer] = useState(null);
  const loadCustomerAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceCustomer(dataSourceDB);
  }, []);
  const handelreferenceChange = (e) => {
    const name = "reference";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const ApplyFilterForCustomerAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceCustomer(dataSourceDB);
  }
  const loadCarrierAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDataSourceCarrier(shipperDataSource);

  }, []);
  const handleConsigneeChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    setConsigneeData(e.value);
    if (e.value != undefined) {
      setConsigneeInfo(getConsigneeInfo(e.value));
    }
    else {
      setConsigneeInfo("");
    }

  }, []);
  const handelConsigneeInfoChange = (e) => {
    const name = "consigneeInfo";
    const value = e.value;
    if (value) {
      setTransaction((prevTransaction) => ({
        ...prevTransaction,
        [name]: value,
      }));
    }
  };
  const [dateSourceConsignee, setDateSourceConsignee] = useState(null);
  const loadConsigneeAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });

    setDateSourceConsignee(dataSourceDB);
  }, []);
  const ApplyFilterForConsigneeAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceConsignee(dataSourceDB);
  }
  const handelUerDefinedReference2rChange = (e) => {

    const name = "userDefinedReference2";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const handleCarrierChange = useCallback((e) => {

    console.log(e);
    setCarrierData(e.value);
  }, []);
  const ApplyFilterForCarrierAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDataSourceCarrier(shipperDataSource);
  }
  const handelShipperBolChange = (e) => {
    const name = "shipperbolnumber";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelTransactionNumberChange = (e) => {

    const name = "transactionnumber";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  //////////Customer AutoComponent/////////////////////// 
  //////////Shipper AutoComponent///////////////////////
  const shipperRef = useRef({});
  const [dateSourceSupplier, setDateSourceSupplier] = useState(null);
  const handleShipperChange = useCallback((e) => {

    console.log(e);
    setShipperData(e.value);
  }, []);
  const loadShipperAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceSupplier(dataSourceDB);
  }, []);

  const ApplyFilterForShipperAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceSupplier(dataSourceDB);
  }
  //////////Shipper AutoComponent///////////////////////


  const handelTransactionDateChange = (e) => {
    const name = "transactiondate";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const handleClicPopUpkOpen = () => {
    setAddConsigneePopup(true);
  };
  const hideLoadPanel = useCallback(() => {
    setLoadPanelVisible(false);
  }, [setLoadPanelVisible]);
  return (
    <div>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={position}
        onHiding={hideLoadPanel}
        visible={loadPanelVisible}
        showIndicator={showIndicator}
        shading={shading}
        showPane={showPane}
        hideOnOutsideClick={hideOnOutsideClick}
      />
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            {loading &&
              <LoadIndicator height={40} width={40} style={{position:"absolute", left:"50%", top:"50%"}}/>
            }
            <form onSubmit={(e) => onUpdateTransaction(e)}>
              <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                  if (e.currentTarget === e.target) {
                    selectionChanged(e, e.target);
                  }
                }}
                className=""
                itemTitleRender={() => (
                  <ToolbarAccordian className="accordian-toolbar">
                    <ItemAccordian location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {props.rolePermission === PermissionsConstants.TransactionReceipt
                            ? "Change Receipt "
                            : "Change Shipment"}
                        </h6>
                      </div>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Save" type="default"
                        onClick={(e) => onUpdateTransaction(e)} />
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      {(props.rolePermission === PermissionsConstants.TransactionReceipt && allowedReceiptDeleteBtn) || allowedShipmentDeleteBtn ?
                        (
                          <div>
                            <Button className="accordianButton" text="Delete"
                              onClick={(e) => handleOpenReceiptDialog(e)}
                            />
                            <DeleteReceiptDialog
                              open={deleteReceiptDialogOpen}
                              handleClose={handleCloseReceiptDialog}
                              rowid={rowId}
                              transactionNumber={transactionnumber}
                            />
                          </div>
                        )
                        : ("")
                      }

                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button
                        className="accordianButton" onClick={(e) => exportReport(e)}
                        disabled={printButtonDisabled}
                      >
                        <LoadIndicator  style={{height: "16px", width: "16px", display: "inline-bloc",  verticalAlign: "middle", marginRight: "5px"}} visible={loadIndicatorVisible} />
                        <span className="dx-button-text">Print</span>
                      </Button>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Back" onClick={backToMainGrid} />
                    </ItemAccordian>
                  </ToolbarAccordian>
                )}
                itemRender={(itemProps) => (
                  <div style={{ height: '238px', overflowY: 'auto' }}>
                    {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ?
                      <div className="row">
                        <div className="col-md-3 d-flex align-items-center">
                          <div className="col-md-11 auto-complete-selectbox">
                            <TextBox
                              id="transaction-profile"
                              disabled
                              stylingMode='outlined'
                              labelMode="static"
                              label="Profile Code:"
                              defaultValue=""
                              name="profile"
                              value={transaction.profilecode}
                            />
                          </div>

                        </div>
                        <div className="col-md-3 d-flex align-items-center">
                          <div className="col-md-11 auto-complete-selectbox">
                            <SelectBox
                              dataSource={dateSourceCustomer}
                              value={customerData}
                              searchEnabled={true}
                              disabled={true}
                              searchMode="contains"
                              onValueChanged={(e) => handleCustomerChange(e)}
                              label="Customer ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"
                            >
                            </SelectBox>
                          </div>

                          {customerDisabled ? (
                            <span></span>
                          ) : (
                            <Button
                              icon="search"
                              onClick={() => openSearchIdsForm(customerLookup)}
                              stylingMode="text"

                            />

                          )}
                        </div>
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date:"
                            defaultValue=''
                            type="date"
                            disabled={isDisabled}
                            value={transactiondate}
                            name="transactiondate"
                            onValueChanged={(e) => handelTransactionDateChange(e)}
                          />

                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="transaction-no"
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No:"
                            disabled
                            type="text"
                            onChange={(e) => handelTransactionNumberChange(e)}
                            name="transactionnumber"
                            value={transactionnumber}
                          />
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date:"
                            defaultValue=''
                            type="date"
                            disabled={isDisabled}
                            value={transactiondate}
                            name="transactiondate"
                            onValueChanged={(e) => handelTransactionDateChange(e)}
                          />

                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="transaction-no"
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No:"
                            disabled
                            type="text"
                            onChange={(e) => handelTransactionNumberChange(e)}
                            name="transactionnumber"
                            value={transactionnumber}
                          />
                        </div>
                        <div className="col-md-3 d-flex align-items-center">
                          <div className="col-md-11 auto-complete-selectbox">
                            <SelectBox
                              dataSource={dataSourceCarrier}
                              value={carrierData}
                              searchEnabled={true}
                              
                              searchMode="contains"
                              onValueChanged={(e) => handleCarrierChange(e)}
                              label="Carrier ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"
                            />
                          </div>
                          <Button
                            icon="search"
                            onClick={() => openSearchIdsForm(carrierLookup)}
                            stylingMode="text"
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="reference"
                            name="reference"
                            stylingMode='outlined'
                            labelMode="static"
                            label="P.O. No:"
                            defaultValue=""
                            value={reference}
                            onValueChanged={(e) => handelreferenceChange(e)}
                          >
                          </TextBox>
                        </div>
                      </div>
                    }
                    <div className="row accordianLastRow">
                      <div className="col-md-3 d-flex align-items-center">
                        {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                          <div className="col-md-11 auto-complete-selectbox"  >
                            <SelectBox
                              dataSource={dateSourceConsignee}
                              value={consigneeData}
                              disabled={consigneeIdInputToDisable}
                              searchEnabled={true}
                              searchMode="contains"
                              onValueChanged={(e) => handleConsigneeChange(e)}
                              label="Consignee ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"
                            >
                            </SelectBox>
                          </div>
                        )
                          :
                          (
                            <div className="col-md-9 auto-complete-selectbox">
                              <SelectBox
                                dataSource={dateSourceConsignee}
                                value={consigneeData}
                                disabled={consigneeIdInputToDisable}
                                searchEnabled={true}
                                searchMode="contains"
                                onValueChanged={(e) => handleConsigneeChange(e)}
                                label="Consignee ID:"
                                labelMode='static'
                                stylingMode='outlined'
                                displayExpr="identityId"
                              >
                              </SelectBox>
                            </div>
                          )
                        }

                        {renderConsigneeSearchButton(consigneeSearchDisable)}
                        {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                          ""
                        ) : props.oidc.user.profile.hasOwnProperty("CREATECONSIGNEE") && props.oidc.user.profile.CREATECONSIGNEE === "Y" ? (
                          <div style={{ color: props.permission }}>
                            <Button id="btnAddConsignee" className="accordianButton custom-button_min_width" onClick={handleClicPopUpkOpen} type="default" text="Add">
                            </Button>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-3 d-flex align-items-center">
                        <div className="col-md-11 auto-complete-selectbox">
                          <SelectBox
                            dataSource={dateSourceSupplier}
                            value={shipperData}
                            searchEnabled={true}
                            searchMode="contains"
                            onValueChanged={(e) => handleShipperChange(e)}
                            label="Shipper ID:"
                            labelMode='static'
                            stylingMode='outlined'
                            displayExpr="identityId"
                          >
                          </SelectBox>
                        </div>
                        <Button
                          icon="search"
                          onClick={() => openSearchIdsForm(1)}
                          stylingMode="text"

                        />


                      </div>
                      <div className="col-md-3">
                        <TextBox
                          id="transactionNo"
                          name="shipperbolnumber"
                          stylingMode='outlined'
                          labelMode="static"
                          label="Shipper BOL:"
                          defaultValue=""
                          value={shipperbolnumber}
                          onValueChanged={(e) => handelShipperBolChange(e)}
                        />
                      </div>

                      {(props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "A") ? (
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Receiving/Shipping Date:"
                            defaultValue=''
                            type="date"
                            name="actualreceivedshipeddate"
                            value={actualreceivedshipeddate}
                            onValueChanged={(e) => handelShippingDateChange(e)}
                            showClearButton={true}
                          />
                          {/* {transaction.actualreceivedshipeddate === "" ? (
                          <span className="error-span">{dateError}</span>
                        ) : (
                          <span></span>
                        )} */}
                        </div>
                      ) : (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "B") ? (
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Receiving/Shipping Date:"
                            defaultValue=''
                            type="date"
                            disabled="true"
                            name="actualreceivedshipeddate"
                            value={actualreceivedshipeddate}
                            onValueChanged={(e) => handelShippingDateChange(e)}
                          />
                        </div>
                      ) : ""}





                    </div>
                    <div className="row accordianLastRow">
                      <div className="col-md-3">
                        <TextArea
                          value={consigneeInfo}
                          label="Consignee Info"
                          labelMode='static'
                          stylingMode='outlined'
                          readOnly={true}
                        />

                      </div>
                      <div className="col-md-3">
                        <TextArea
                          name="comment"
                          value={comment}
                          onValueChanged={(e) => handelCommentChange(e)}
                          label="Comment"
                          labelMode='static'
                          stylingMode='outlined'
                        >
                        </TextArea>
                      </div>
                      {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") &&
                        props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
                          <>
                            <div className="col-md-3 d-flex  ">
                               
                                <div className="col-md-11 auto-complete-selectbox">
                                  <SelectBox
                                    dataSource={dataSourceCarrier}
                                    value={carrierData}
                                    searchEnabled={true}
                                  
                                    searchMode="contains"
                                    onValueChanged={(e) => handleCarrierChange(e)}
                                    label="Carrier ID:"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    displayExpr="identityId"
                                  />
                                </div>
                                <Button
                                  icon="search"
                                  onClick={() => openSearchIdsForm(carrierLookup)}
                                  stylingMode="text"
                                  style={{paddingTop:'10px'}}

                                />
                               

                            </div>
                            <div className="col-md-3">
                              <TextBox
                                id="reference"
                                name="reference"
                                stylingMode='outlined'
                                labelMode="static"
                                label="P.O. No:"
                                defaultValue=""
                                value={reference}
                                onValueChanged={(e) => handelreferenceChange(e)}
                              >
                              </TextBox>
                            </div>
                          </>
                        )}
                      {props.rolePermission === PermissionsConstants.TransactionShipment
                        ?
                        <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                          <div className="col-md-12 auto-complete-selectbox">
                            <SelectBox
                              items={[
                                { Name: "None", tab: 0, ID: "N" },
                                { Name: "Prepaid", tab: 1, ID: "P" },
                                { Name: "Collect", tab: 2, ID: "C" },
                                { Name: "Bill Third Party", tab: 3, ID: "B" }
                              ]}
                              searchMode="contains"
                              label="Freight Charge Type:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="Name"
                              valueExpr="ID"
                              onValueChanged={onItemClick}
                              defaultValue="N"
                              value={freightChargeType}
                            >
                            </SelectBox>
                          </div>

                        </div>
                        : ""}

                      {
                        props.rolePermission === PermissionsConstants.TransactionShipment ?
                          <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                            <TextBox
                              id="transactionGroup"
                              name="transactionGroup"
                              stylingMode='outlined'
                              labelMode="static"
                              label="Sales Order No:"
                              defaultValue=""
                              value={transactionGroup}
                              onValueChanged={(e) => handelSalesOrderChange(e)}
                            />
                          </div> : null
                      }
                       {props.rolePermission === PermissionsConstants.TransactionShipment
                        ?
                        <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                        <TextBox
                          id="userDefinedReference2"
                          name="userDefinedReference2"
                          stylingMode='outlined'
                          labelMode="static"
                          label={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Trucker Ref:')}
                          defaultValue=""
                         // value={transaction.userDefinedReference2}
                          value={userDefinedReference2}
                          onValueChanged={(e) => handelUerDefinedReference2rChange(e)}
                        />
                      </div>
                        : ""}
                    </div>
                    <div style={{ display: 'flex', border: '0px solid black', marginTop: '12px' }}>
                      <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderTopLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Record #:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {recordNumber || ''}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Total Lines:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.items}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Ordered:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.ordered}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Actual:
                      </div>
                      <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderTopRightRadius: '12px', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.actual}
                      </div>
                    </div>
                    <div style={{ display: 'flex', border: '0px solid black', marginBottom: '12px' }}>
                      <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderBottomLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Net Weight:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.netWeight}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Gross Weight:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.grossWeight}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Amount:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.amount}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                      </div>
                      <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderBottomRightRadius: '12px', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                )}
                id="accordion-container"
              />
            </form>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "0px" }}>
      <ItemModeGrid
          key={reloadKey} 
          displayItemModeGrid={displayItemModeGrid}
          detailDataGridModes={detailDataGridModes}
          selectedValue={selectedValue}
          detailDataGridModeChanged={detailDataGridModeChanged}
          searchPanelStatus={searchPanelStatus}
          headerId={headerId}
          visible={displayItemModeGrid}
          selectedCustomerId={transaction.rCustomer}
        />
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
         visible={!displayItemModeGrid}
          remoteOperations={true}
          showBorders={true}
          ref={detailDataGrid}
          className={searchPanelStatus ? "StyleGridHightWithAccordianOpen" : "StyleGridHightWithAccordianClose"}
          hoverStateEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
          onRowUpdating={(e) => onChangeReceiptQuantityUpdate(e)}
          onRowUpdated={onRowUpdated}
        >
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <ColumnFixing enabled={true} />
          <ColumnHeaderFilter />
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting visible={true} mode="multiple" />
          <LoadPanel enabled={true} />
          <Paging defaultPageSize={100} />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
          />
          <FilterRow visible={true} />
          <Editing mode="cell" allowUpdating={true} refreshMode="repaint" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={false} />
          <GroupPanel visible={true} />
          <Grouping autoExpandAll={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={saveState}
          />
          <Column dataField="isselected" dataType="boolean" caption="">
          </Column>
          <Column
            dataField="quantityorder"
            dataType="number"
            caption="Ordered"
          ></Column>
          <Column
            dataField="itemcode"
            caption="Item"
            allowEditing={false}
          ></Column>
          <Column
            dataField="description1"
            caption="Item Description - 1"
            allowEditing={false}
          ></Column>

          <Column
            dataField="classcode"
            caption="Class"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="palletsizecode"
            caption="PalletSizeCode"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="subclasscode"
            caption="SubClass"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="status"
            caption="Status"
            allowEditing={false}
          ></Column>
          <Column
            dataType="date"
            dataField="dateavailable"
            caption="Item Date Available"
            allowEditing={false}
          ></Column>
          <Column
            dataType="date"
            dataField="dateexpiration"
            caption="Item Date Expiration"
            allowEditing={false}
          ></Column>
          <Column
            dataField="netavailable"
            caption="Item Net Avl"
            allowEditing={false}
          ></Column>
          <Column
            dataField="receiptuomdefault"
            caption="UOM Default"
            allowEditing={false}
          ></Column>
          <Column
            dataField="receiptpacksize"
            caption="Pack Size"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column dataField="lotcode" caption="Lot" allowEditing={false}></Column>
          <Column
            dataField="lotDescription1"
            caption="Lot Description - 1"
            allowEditing={false}
          ></Column>
          <Column
            dataField="lotDescription2"
            caption="Lot Description - 2"
            allowEditing={false}
            visible={false}>
          </Column>
          <Column
            dataField="lotUserdefinedreference8"
            caption="Lot Reference 8"
            allowEditing={false}
            visible={false}>
          </Column>
          <Column
            dataField="lotNetavailable"
            caption="Lot Net Avl"
            allowEditing={false}
          ></Column>
          <Column
            dataType="date"
            dataField="lotDateExpiration"
            caption="Lot Date Expiration"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataType="date"
            dataField="LotDateAvailable"
            caption="Lot Date Available"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataType="date"
            dataField="Dateintroduced"
            caption="Lot Date Introduced"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="lotUnitPerPackage"
            caption="Lot Units / Package"
            allowEditing={false}
            visible={false}>
          </Column>
          <Column
            dataField="lotFirstReceipt"
            caption="Lot First Receipt"
            allowEditing={false}
            visible={false}>
          </Column>
          <Toolbar>
            <Item>
              <SelectBox
                stylingMode='outlined'
                width="201"
                items={detailDataGridModes}
                displayExpr="text"
                valueExpr="value"
                value={selectedValue}
                onValueChanged={detailDataGridModeChanged}
                onContentReady={onContentReady} />
            </Item>
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
      <div style={{ flex: 1 }}>
        <div className="row">
          <div className="col-md-12 mt-4">
            <div className="d-flex align-items-center">
              {addConsigneePopup &&
                <Popup
                  visible={addConsigneePopup}
                  onHiding={hideConsigneePopup}
                  dragEnabled={false}
                  hideOnOutsideClick={true}
                  showCloseButton={true}
                  showTitle={true}
                  title="Add Consignee"
                  container="#root"
                  closeOnOutsideClick={true}
                  height="61vh"
                  width="75vw"
                >
                  <ScrollView width="100%" height="100%">
                    <Consignee
                      parentCallback={handleClosePopUpCallback}
                    ></Consignee>
                  </ScrollView>
                </Popup>
              }
              <LookupPopup
                openLookupForm={openLookupForm}
                closeLookupSearchForm={closeLookupSearchForm}
                onSearchLookupIds={onSearchLookupIds}
                resetLookupForm={resetLookupForm}
                onLookupFieldChange={onLookupFieldChange}
                identityIdFrom={identityIdFrom}
                identityIdTo={identityIdTo}
                name={name}
                lookupFormName={lookupFormName}
                lookupDataList={lookupDataList}
                dataGrid={dataGrid}
                onSelectionChanged={onSelectionChanged}
              />
              <Popup
                visible={openDialogForTransaction}
                onHiding={handleClose}
                title={props.rolePermission ===
                  PermissionsConstants.TransactionReceipt
                  ? "Receipt Changed!"
                  : "Shipment Changed!"}
                showCloseButton={true}
                width={600} // Adjust width as needed
                height="auto" // Adjust height as needed
                className="cDialog"
              >

                <h5
                  style={{
                    fontWeight: "500",
                    marginTop: "10px",
                  }}
                >
                  {props.rolePermission ===
                    PermissionsConstants.TransactionReceipt
                    ? "Your receipt has been changed."
                    : "Your Shipment has been changed"}
                </h5>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginLeft: '0px',
                    marginTop: '30px',
                  }}
                >

                  <Button
                    onClick={closeDialogForTransaction}
                    className="accordianButton"
                    text="Back"
                  >

                  </Button>

                </div>
              </Popup>
              <Popup
                visible={concurrentDialogForTransaction}
                onHiding={handleClose}
                title={props.rolePermission ===
                  PermissionsConstants.TransactionReceipt
                  ? "Receipt has been Updated by another User."
                  : "Shipment has been Updated by another User"}
                showCloseButton={true}
                width={600} // Adjust width as needed
                height="auto" // Adjust height as needed
                className="cDialog"
              >
                <h5
                  style={{
                    fontWeight: "500",
                    marginTop: "10px",
                  }}
                >
                  {props.rolePermission ===
                    PermissionsConstants.TransactionReceipt
                    ? "Please Refresh the screen and reload the Receipt ."
                    : "Please Refresh the screen and reload the Shipment"}
                </h5>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginLeft: '0px',
                    marginTop: '30px',
                  }}
                >

                  <Button
                    onClick={refreshChangeTransaction}
                    className="accordianButton"
                    text="Refresh"
                  >

                  </Button>

                </div>
              </Popup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ChangeReceipt);
